import { Tag } from "antd";
import { AlertTriangle, CheckCircle2, Clock, FileText, User } from "lucide-react";

import type { AccountDetailVO } from "@/api/accounts/type";
import { SectionTitle } from "@/components/DetailBlocks";
import { cn } from "@/lib/cn";
import { emptyPlaceholder } from "@/utils";

import { RISK_COLOR_MAP } from "../constants";
import { DetailInfoRow } from "./detailParts";

/** Tab：风险控制 */
export const RiskTab = ({ accountDetail }: { accountDetail: AccountDetailVO | null }) => (
  <div className="space-y-5">
    <div>
      <SectionTitle icon={AlertTriangle} title="风险状态" />
      <div className="grid grid-cols-2 gap-x-6 gap-y-2.5">
        <div className="flex items-center gap-1.5 text-sm">
          <AlertTriangle className="w-3.5 h-3.5 text-slate-400 shrink-0" />
          <span className="text-slate-500 w-24 shrink-0">风险等级</span>
          <Tag
            bordered
            className={cn(
              "text-[10px] m-0 border-0",
              accountDetail?.riskLevel ? RISK_COLOR_MAP[accountDetail.riskLevel] : undefined,
            )}
          >
            {accountDetail?.riskLevel}
          </Tag>
        </div>
        <DetailInfoRow
          icon={FileText}
          label="标记原因"
          value={emptyPlaceholder(accountDetail?.riskReason)}
        />
        <DetailInfoRow
          icon={Clock}
          label="标记时间"
          value={emptyPlaceholder(accountDetail?.riskMarkTime)}
        />
        <DetailInfoRow
          icon={User}
          label="标记操作人"
          value={emptyPlaceholder(accountDetail?.riskMarkOperator)}
        />
      </div>
    </div>
    {accountDetail?.riskLevel === "正常" && (
      <div className="p-3 bg-emerald-50 border border-emerald-200 rounded-lg text-sm text-emerald-700 flex items-center gap-2">
        <CheckCircle2 className="w-4 h-4 shrink-0" />
        该账号风险状态正常，无风险标记记录
      </div>
    )}
  </div>
);
